/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_Boundary_TermInputs */

const en_how_we_work_brief_boundary_term = /** @type {(inputs: How_We_Work_Brief_Boundary_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boundary`)
};

const lv_how_we_work_brief_boundary_term = /** @type {(inputs: How_We_Work_Brief_Boundary_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robeža`)
};

/**
* | output |
* | --- |
* | "Boundary" |
*
* @param {How_We_Work_Brief_Boundary_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_boundary_term = /** @type {((inputs?: How_We_Work_Brief_Boundary_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_Boundary_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_boundary_term(inputs)
	return en_how_we_work_brief_boundary_term(inputs)
});